export default async function DeleteProjectExpense(id) {
    let url = window.RealestateService+  `/api/ProjectExpense/DeleteProjectExpense?id=${id}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"POST",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}